<template>
  <label>
    <slot />
    <textarea class="cw-textarea" @keydown.enter.exact.prevent="this.hitEnter" @keydown.enter.shift.exact.prevent="this.model += '\n'" v-model="this.model" rows="1" v-autogrow enterkeyhint="send" />
  </label>
</template>

<script lang="ts">
import { Component, Model, Vue } from 'vue-facing-decorator';

import { autogrow } from "@/directives";

@Component({
  emits: ["update:modelValue", "enter"],
  directives: { autogrow },
})
export default class TickTextarea extends Vue {
  @Model({ required: true }) private value!: string;

  private get model() {
    return this.value;
  }

  private set model(to) {
    this.$emit("update:modelValue", to);
  }

  private hitEnter() {

    this.$emit("enter");
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/theme";

.cw-textarea {
  //padding: 4px 4px 0 4px;
  //border-radius: 4px;
  //font-size: 1em;
  //line-height: 16px;
  height: auto;
  //border: solid 1px #efefef;
  display: block;
  width: 100%;
  //padding: 5px;
  touch-action: none; // disable zoom on mobile devices'
  min-height: 40px;
}
</style>
